<template>
  <v-container id="eligibleVoters" tag="section">
    <v-overlay :value="overlay">
      <v-progress-circular :size="70" :width="7" color="blue" indeterminate></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar.active">
      {{ snackbar.text }}
    </v-snackbar>

    <v-dialog v-model="openDialog" width="500">
      <v-card>
        <v-card-title class="headline green white--text">
          {{ editingId ? 'Editar eleitor' : 'Novo eleitor' }}
          <v-spacer />
          <v-btn text @click="clearFields()"><v-icon large color="white">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-text-field v-model="name" class="ma-5" label="Nome" outlined></v-text-field>
        <v-text-field v-model="cpf" class="ma-5" label="CPF" outlined></v-text-field>
        <v-text-field v-model="email" class="ma-5" label="E-mail" outlined></v-text-field>
        <v-text-field v-model="phone" class="ma-5" label="Telefone" outlined></v-text-field>
        <v-text-field v-model="funcional" class="ma-5" label="Funcional" outlined></v-text-field>
        <v-select v-model="banks" class="ma-5" label="Bancos" :items="bankOptions" multiple outlined></v-select>
        <v-select v-model="affiliation_status" class="ma-5" label="Afiliação" :items="affiliationStatusOptions" outlined></v-select>
        <v-select v-model="status" class="ma-5" label="Status" :items="statusOptions" outlined></v-select>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="save()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="openImportDialog" width="600">
      <v-card>
        <v-card-title class="headline orange white--text">
          Importar eleitores
          <v-spacer />
          <v-btn text @click="openImportDialog = false"><v-icon large color="white">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-5">
          <input type="file" accept=".xlsx" @change="onFileSelected" />
          <div v-if="importReport" class="mt-3">
            <p>Total: {{ importReport.total }} — importados/atualizados: {{ importReport.inserted_or_updated }}</p>
            <ul>
              <li v-for="error in importReport.errors" :key="error.row">Linha {{ error.row }}: {{ error.reason }}</li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-btn color="primary" class="ma-2 white--text" @click="openCreate()">
      <v-icon left>mdi-plus</v-icon>Novo eleitor
    </v-btn>
    <v-btn color="orange" class="ma-2 white--text" @click="openImportDialog = true">
      <v-icon left>mdi-upload</v-icon>Importar planilha
    </v-btn>
    <v-btn color="green" class="ma-2 white--text">
      <export-excel
        class="btn btn-default"
        :fetch="fetchExportRows"
        :fields="json_fields"
        worksheet="Eleitores"
        name="Eleitores.xls"
      >
        <v-icon left dark>mdi-download</v-icon>Exportar lista de eleitores
      </export-excel>
    </v-btn>

    <v-text-field
      v-model="search"
      class="ma-2"
      label="Buscar por nome ou CPF"
      prepend-inner-icon="mdi-magnify"
      outlined
      dense
      clearable
      @input="onSearchInput"
    ></v-text-field>

    <tables
      :title="title"
      :columns="columns"
      :linesData="linesData"
      :itemsPerPage="pageSize"
      @action="action($event)"
      :actionsOptions="actionsOptions"
    />

    <div class="text-center">
      <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" total-visible="7" class="my-4" @input="getAll()"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import eligibleVoterService from "../../../../service/eligibleVoterService";
import votingService from "../../../../service/votingService";

export default {
  name: "eligibleVoters",
  components: {
    Tables: () => import("../../../../components/cms/Tables")
  },
  data: () => ({
    title: "Eleitores",
    columns: ["Nome", "CPF", "Bancos", "Afiliação", "Status", "Ações"],
    actionsOptions: ["edit", "delete"],
    linesData: [],
    eligibleVoters: [],
    bankOptions: [],
    editingId: null,
    id: null,
    name: "",
    cpf: "",
    email: "",
    phone: "",
    funcional: "",
    banks: [],
    affiliation_status: "nao_associado",
    affiliationStatusOptions: [
      { value: "associado", text: "Associado" },
      { value: "nao_associado", text: "Não associado" }
    ],
    status: "active",
    statusOptions: [
      { value: "active", text: "Ativo" },
      { value: "inactive", text: "Inativo" }
    ],
    openDialog: false,
    openImportDialog: false,
    importReport: null,
    overlay: false,
    snackbar: { text: "", active: false },
    page: 1,
    pageSize: 20,
    total: 0,
    search: "",
    searchTimer: null,
    json_fields: {
      "Nome": "name",
      "CPF": "cpf",
      "Bancos": "banks",
      "Afiliação": "affiliation_label",
      "Status": "status_label"
    }
  }),
  methods: {
    action($event) {
      switch ($event.type) {
        case "edit":
          this.openEdit($event.id);
          break;
        case "delete":
          this.remove($event.id);
          break;
        default:
          break;
      }
    },
    statusLabel(status) {
      return status === "active" ? "Ativo" : "Inativo";
    },
    // Evita injeção de fórmula (CSV/Excel formula injection): um valor
    // vindo de cadastro/import começando com =, +, -, @, tab ou CR pode
    // ser interpretado como fórmula ao abrir o arquivo exportado.
    sanitizeForExport(value) {
      const text = value === null || value === undefined ? "" : String(value);
      return /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
    },
    affiliationLabel(affiliationStatus) {
      return affiliationStatus === "associado" ? "Associado" : "Não associado";
    },
    getAll() {
      this.overlay = true;
      const params = { page: this.page, pageSize: this.pageSize, search: this.search || undefined };
      eligibleVoterService.get(params).then(res => {
        this.eligibleVoters = res.data.items;
        this.total = res.data.total;
        this.linesData = res.data.items.map(voter => ({
          id: voter.id,
          lines: [
            { width: 22, name: voter.name },
            { width: 16, name: voter.cpf },
            { width: 20, name: voter.banks || "-" },
            { width: 13, name: this.affiliationLabel(voter.affiliation_status) },
            { width: 10, name: this.statusLabel(voter.status) }
          ]
        }));
        this.overlay = false;
      }).catch(() => {
        this.overlay = false;
      });
    },
    // A exportação traz a lista completa (sem paginação), não só a página e a busca atuais.
    fetchExportRows() {
      return eligibleVoterService.get({ all: true }).then(res => res.data.items.map(voter => ({
        name: this.sanitizeForExport(voter.name),
        cpf: this.sanitizeForExport(voter.cpf),
        banks: this.sanitizeForExport(voter.banks || "-"),
        affiliation_label: this.affiliationLabel(voter.affiliation_status),
        status_label: this.statusLabel(voter.status)
      })));
    },
    onSearchInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getAll();
      }, 400);
    },
    getBanks() {
      votingService.getBankParam({}).then(res => {
        this.bankOptions = res.data.bank.map(bank => ({ value: bank.id, text: bank.name }));
      });
    },
    openCreate() {
      this.clearFields();
      this.openDialog = true;
    },
    openEdit(id) {
      const voter = this.eligibleVoters.filter(v => v.id === id)[0];
      this.editingId = id;
      this.name = voter.name;
      this.cpf = voter.cpf;
      this.email = voter.email;
      this.phone = voter.phone;
      this.funcional = voter.funcional;
      this.banks = voter.bank_ids ? String(voter.bank_ids).split(",").map(Number) : [];
      this.affiliation_status = voter.affiliation_status;
      this.status = voter.status;
      this.openDialog = true;
    },
    save() {
      const payload = {
        name: this.name,
        cpf: this.cpf,
        email: this.email,
        phone: this.phone,
        funcional: this.funcional,
        banks: this.banks,
        affiliation_status: this.affiliation_status,
        status: this.status
      };

      this.overlay = true;
      const request = this.editingId
        ? eligibleVoterService.update(this.editingId, payload)
        : eligibleVoterService.create(payload);

      request.then(() => {
        this.overlay = false;
        this.clearFields();
        this.getAll();
      }).catch(() => {
        this.overlay = false;
        this.snackbar.text = "Erro ao salvar eleitor.";
        this.snackbar.active = true;
      });
    },
    remove(id) {
      this.overlay = true;
      eligibleVoterService.delete(id).then(() => {
        this.overlay = false;
        this.getAll();
      });
    },
    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);

      this.overlay = true;
      eligibleVoterService.import(formData).then(res => {
        this.overlay = false;
        this.importReport = res.data;
        this.getAll();
      }).catch(() => {
        this.overlay = false;
        this.snackbar.text = "Erro ao importar planilha.";
        this.snackbar.active = true;
      });
    },
    clearFields() {
      this.editingId = null;
      this.name = "";
      this.cpf = "";
      this.email = "";
      this.phone = "";
      this.funcional = "";
      this.banks = [];
      this.affiliation_status = "nao_associado";
      this.status = "active";
      this.openDialog = false;
    }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.total / this.pageSize));
    }
  },
  mounted() {
    this.getAll();
    this.getBanks();
  }
};
</script>
